import { AddDriverComponent } from './add-driver/add-driver.component';
import { CreateDriverComponent } from './create-driver/create-driver.component';
import { EditDriverComponent } from './edit-driver/edit-driver.component';
import { EditdriverComponent } from './editdriver/editdriver.component';
import { SingleViewDriverComponent } from './view-driver/single-view-driver.component';
import { ViewDriverComponent } from './view-driver/view-driver.component';
import { EventDriverComponent} from './event-driver/event-driver.component'

export const DriverRouting: any = [
    { path: '', redirectTo: 'view-driver', pathMatch: 'full' },
    // {path : '' , component:ViewDriverComponent},
    { path: 'create-driver', component: AddDriverComponent},
    { path: 'add-driver', component: CreateDriverComponent},
    { path: 'view-driver/:vendorID', component: ViewDriverComponent},
    { path: 'single-view-driver/:vendorID/:driverID', component: SingleViewDriverComponent},
    { path: 'edit-driver/:vendorID/:driverID', component: EditdriverComponent},
    { path: 'preview-driver/:vendorID/:driverID/:view', component: EditdriverComponent},
    {path:'event-driver',component: EventDriverComponent}
    //{ path: 'modify-driver', component: EditDriverComponent},
    
];

export const DriverRoutingBreadcrumbs = [
    // { name: 'View',path:'' },
    // { name: 'View',path:'/view-driver' },
    // { name: 'Single-view',path:'/single-view-driver' },
    // { name: 'Edit', path: '/edit-driver' },
    // { name: 'Add', path: '/add-driver' },

];